// Course fallback content — mirrors the live "course" domain doc.
export const COURSE = {
  published: true,
  name: "LA Tour",
  location: "",
  label: "Black Tees · Par 72 · 7,092 Yards · Rating 74.3 · Slope 135",
  goodToKnow: [
    { id: "dress-code", title: "Dress Code", body: "Standard golf attire — collared shirts, no denim. Soft spikes only." },
    { id: "carts", title: "Carts", body: "Two carts per team. Follow all posted cart-path signs and keep carts clear of tees and greens." },
    { id: "practice", title: "Practice Facilities", body: "Driving range and putting green open on arrival — loosen up before the opening ceremony." },
    { id: "pace", title: "Pace of Play", body: "Keep up with the group ahead. Ready golf all day — the goal is four and a half hours." },
    { id: "phones", title: "Cell Phones", body: "Phones are welcome for scoring and photos — silent on the tees, please." },
    { id: "weather", title: "Weather Plan", body: "We play rain or shine. Lightning stops play — head straight to the clubhouse." },
    { id: "food", title: "Food & Beverage", body: "Water stations on the course. Lunch, drinks, and the after party are back at Gennaro's." },
    { id: "photographer", title: "Photographer Onsite", body: "Our photographer is with us all day — smile for the Trophy Wall." },
  ],
};
